var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{staticClass:"btn dealers_btn",staticStyle:{"font-size":"15px"},attrs:{"to":{name:  'disconnected_pumps_history', query: {pumpId: _vm.data.pumpId, companyId: this.$route.query.companyId}}}},[_vm._v("\n      "+_vm._s(_vm.$t('text.clickButtons.viewHistory'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }